import React from "react";

import { MobileAppCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function mobileApp({ width, onResize }: Column.Options) {
	return base(ColumnId.MobileApp, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default mobileApp;
